import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';
import { IS_MAGIC_TEAM } from '../lib/brand';

const DEFAULT_SHELL = IS_MAGIC_TEAM
  ? 'app-page-shell pb-page-with-bottom-nav md:pb-8'
  : 'min-h-screen bg-white pb-page-with-bottom-nav md:pb-8';

const SHELL_BY_PATH = IS_MAGIC_TEAM
  ? {
      '/contatti': 'app-page-shell pb-page-with-bottom-nav md:pb-0',
      '/carriera': 'app-page-shell pb-page-with-bottom-nav md:pb-0',
      '/carriera/grafici': 'app-page-shell pb-page-with-bottom-nav md:pb-0',
      '/calendario': 'app-page-shell pb-page-with-bottom-nav md:pb-0',
    }
  : {
      '/contatti': 'min-h-screen bg-white pb-page-with-bottom-nav md:pb-0',
      '/carriera': 'min-h-screen bg-zinc-50 pb-page-with-bottom-nav md:pb-0',
      '/carriera/grafici': 'min-h-screen bg-zinc-50 pb-page-with-bottom-nav md:pb-0',
      '/calendario': 'min-h-screen bg-zinc-50 pb-page-with-bottom-nav md:pb-0',
    };

export default function AppShell({ showBottomNav = true }) {
  const { pathname } = useLocation();
  const shellClass = SHELL_BY_PATH[pathname] ?? DEFAULT_SHELL;

  return (
    <div className={shellClass}>
      <Header />
      <Outlet />
      {showBottomNav ? <BottomNav /> : null}
    </div>
  );
}
